import styled from 'styled-components';
import colors from 'Styles/colors';
import { FiTrash2 as Trash } from 'react-icons/fi';

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 0 27px 0;
  border-radius: 4px;
`;
Wrapper.displayName = 'Wrapper';

export const WrapperField = styled.div`
  padding-bottom: 10px;
`;
WrapperField.displayName = 'WrapperField';

export const Label = styled.div`
  user-select: none;
  margin-bottom: 20px;
  font-size: 12.5px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.text.runAgentDescription};
  &:after{
    content: "*";
    color: red;
    margin-left: 5px;
  }
`;
Label.displayName = 'Label';

export const WorkspaceList = styled.div`
  width: 100%;
  height: 100%;
  max-height: 138px;
  border: solid 1px  ${({ theme }) => theme.borders.actionDropDown};
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin-top: 19px;
  background-color: ${({ theme }) => theme.backgrounds.workspaceList};
`;
WorkspaceList.displayName = 'WorkspaceList';

export const Workspace = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 17px;
  background-color: ${(props) => (props.isOdd ? props.theme.backgrounds.listItemOdd : props.theme.backgrounds.listItemEven)};
`;
Workspace.displayName = 'Workspace';

export const Name = styled.span`
  font-size: 12.5px;
  font-weight: normal;
  line-height: 2.72;
  color: ${({ theme }) => theme.text.workspaceListItem};
  width: 40%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
Name.displayName = 'Name';

export const TrashIcon = styled(Trash)` 
  width: 16px;
  height: 17px;
  color: ${colors.grey12};
`;
TrashIcon.displayName = 'TrashIcon';
